/*
 * @Author: songyzh
 * @Date: 2020-07-27 22:23:29
 * @LastEditors: songyzh
 * @LastEditTime: 2020-07-27 22:23:58
 */
import Login from './login.vue';

export default Login;
